import { Injectable } from '@angular/core';
import { SclUtilUrlService } from '../../../../formbird-sc-shared/src/lib/scl-util-url.service';

@Injectable({
  providedIn: 'root'
})
export class RelatedDocumentService {

    constructor(private sclUtilUrlService: SclUtilUrlService) {}

    openLink(item, event, componentDefinition) {
        event.stopPropagation();
        const openMode = componentDefinition.urlOpenIn || 'currentWindow';
        if (openMode !== 'currentWindow') {
            event.preventDefault();
        }

        if (!(event.shiftKey || event.ctrlKey || event.metaKey)) {
            this.sclUtilUrlService.openLink('/form/' + item.documentId, openMode, this);
        }
    }

    showTemplateDialog(componentDefinition) {
        if (componentDefinition.newTemplate) {
            const link = 'form/' + componentDefinition.newTemplate;
            const openMode = componentDefinition.urlOpenIn ? componentDefinition.urlOpenIn : 'currentWindow';
            this.sclUtilUrlService.openLink(link, openMode, this);
        }
    }

    getValueFromKeyString(obj, keyString) {
        const keys = keyString.split(".");
        let hold = obj;
        for (const key of keys) {
            if (hold[key]) {
                hold = hold[key];
            } else {
                hold = null;
                break;
            }
        }

        return hold;
    }

}